import brandLogoPng from "../../assets/brand-logo.png";
import brandLogoWebp from "../../assets/brand-logo.webp";

export default function BrandLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex flex-col items-center ${className}`} aria-label="Vívelo AI">
      {/* Logo icon - official brand mark */}
      <div className="relative w-28 h-28 md:w-32 md:h-32 flex items-center justify-center">
        <picture>
          <source srcSet={brandLogoWebp} type="image/webp" />
          <img
            src={brandLogoPng}
            alt="Vívelo AI"
            className="w-full h-full object-contain drop-shadow-[0_0_18px_rgba(0,176,255,0.35)]"
            draggable={false}
          />
        </picture>
      </div>

      {/* Text: VÍVELO AI */}
      <div className="flex items-center justify-center mt-0.5 font-heading font-extrabold text-white text-4xl md:text-5xl tracking-tight leading-none">
        <span>VÍVEL</span>
        <span className="relative inline-flex items-center justify-center mx-0.5">
          <span className="text-white">O</span>
          <i className="ri-flashlight-fill absolute text-[11px] md:text-xs text-[#FFD600] -rotate-12"></i>
        </span>
        <span className="text-[#00B0FF] ml-1">AI</span>
      </div>

      {/* Tagline */}
      <div className="mt-2 flex items-center gap-1 text-[10px] md:text-xs tracking-[0.15em] uppercase font-medium">
        <span className="text-foreground-200">DESCUBRE</span>
        <span className="text-primary-400">•</span>
        <span className="text-foreground-200">APREDE</span>
        <span className="text-primary-400">•</span>
        <span className="text-foreground-200">CRECE</span>
        <span className="text-primary-400">•</span>
        <span className="text-foreground-200">COMPARTE</span>
        <span className="text-primary-400">•</span>
        <span className="text-primary-400 font-bold">VÍVELO</span>
      </div>
    </div>
  );
}
